module.exports = __webpack_public_path__ + "img/hust-logo.e3907af4.png";